import React from 'react';

import {
  AnalyticsDataSourceForm,
  ElasticIndexPrefixForm,
  ThemeForm,
} from '@/forms';
import FeaturesForm from '@/forms/features-form/FeaturesForm';
import { AppVersion } from './AppVersion';
import { CogIcon } from './icons';
import Logout from './Logout';
import {
  Card,
  CardBody,
  CardCloseButton,
  CardOptions,
  ControlledModal,
  InlineIconButton,
} from '.';

type Props = {
  buttonClassName?: string;
};

export const GlobalOptions = ({ buttonClassName }: Props) => (
  <ControlledModal
    content={
      <Card
        size="md"
        title="Global options"
        options={
          <CardOptions>
            <CardCloseButton />
          </CardOptions>
        }
      >
        <CardBody className="grid gap-6 p-3">
          <div>
            <ThemeForm />
          </div>
          <div>
            <FeaturesForm />
          </div>
          <div>
            <ElasticIndexPrefixForm />
          </div>
          <div>
            <AnalyticsDataSourceForm />
          </div>
          <div className="flex items-center justify-between gap-3">
            <Logout />
            <AppVersion />
          </div>
        </CardBody>
      </Card>
    }
  >
    <InlineIconButton className={buttonClassName}>
      <CogIcon />
    </InlineIconButton>
  </ControlledModal>
);
